(ns motorsaif.shared.step-form
  (:require
   [reagent.ratom :as ra]
   ;; [motorsaif.mobile.lib.form :as form]
   [motorsaif.validation :as validation]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.string :as mstr :refer [format]]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [taoensso.encore :as encore]))


(def ^:private next-fn-limiter (encore/rate-limiter {:default [1 (encore/ms :secs 0.3)]}))

(def ^:private kw->pred
  {:= =
   :not= not=})

(defn- next-condition [{:keys [form branch] :as argz}]
  (cond (keyword? branch)
        branch
        (map? branch)
        (let [[next-node condition] (first branch)
              [pred path test-val] condition
              pred (or (kw->pred pred) pred)
              {:keys [get-val]} form
              curr-val (get-val path)]
          (when (pred curr-val test-val) next-node))))

(defn- -next-fn [{:keys [*path form steps] :as argz}]
  (let [current-node (get steps (last @*path))
        next (:next current-node)
        ret (cond (vector? next)
                  (some #(next-condition {:branch %
                                          :form form}) next)
                  (keyword? next)
                  next)]
    ret))

(defn validated-inputs [{:keys [form validate]}]
  (let [{:keys [*realtime-validation]} form
        realtime-validation (:human @*realtime-validation)]
    (map #(hash-map :path %
                    :valid (get-in realtime-validation %)) validate)))

(defn make-step-form
  [{:keys [*path init-path steps form prev-fn]}] ; steps-limit is unused in the provided logic
  (let [*path (or *path (r/atom init-path))
        next-fn (fn next-step-fn
                  ([] (next-step-fn nil))
                  ([next-node-k]
                   (let [[_ backoff] (next-fn-limiter true) ; Check rate limit
                         ;; Determine next step: use provided key or calculate
                         next-node (or (when (keyword? next-node-k) next-node-k)
                                       (-next-fn {:form form
                                                  :steps steps
                                                  :*path *path}))]
                     ;; Add to path if a valid next step exists and not rate limited
                     (when (and next-node (not backoff))
                       (swap! *path conj next-node)))))

        prev-fn (or prev-fn
                    (fn default-prev-fn []
                      (when (> (count @*path) 1)
                        (swap! *path pop))))

        current (ra/reaction
                  (let [current-key (last @*path)
                        step-config (get steps current-key)]
                    ;; Ensure the step configuration exists
                    (assert step-config
                            (format "No step found for key: %s" current-key))
                    step-config))

        finish? (ra/reaction (:finish @current))
        validate (ra/reaction (:validate @current))

        percent-complete (ra/reaction (* 100 (/ (dec (count @*path)) (- (count steps) 2))))

        validated (ra/reaction
                    (validated-inputs {:form form :validate @validate}))

        all-valid? (ra/reaction
                     (every? nil? (map :valid @validated)))]

    {
     :next-fn next-fn
     :prev-fn prev-fn
     :current current ; Reaction holding the current step's config map
     :finish? finish? ; Reaction -> boolean
     :percent-complete percent-complete ; Reaction -> number
     :all-valid? all-valid? ; Reaction -> boolean
     :*path *path ; The atom holding the navigation path
     }))
